<template>
    <div class="home container">
        <navTitle title="账户异常自助解限授权协议" :showBack="showback_url" :type="type_url" :url="redirect_url"></navTitle>
        <div class="content">
            您的账户存在异常，需要对您的身份进行验证后才能解除限制。您同意并授权同程网络科技股份有限公司、艺龙网信息技术（北京）有限公司、北京艺龙信息技术有限公司等同属于香港上市公司主体：同程艺龙控股有限公司旗下附属公司，以及我们的合作方（腾讯云计算（北京）有限责任公司）根据国家相关规定，收集、储存、使用您的个人信息以便于为您提供服务时对您的身份进行必要的验证。上述的个人信息根据不同的使用场景或服务可能包括：<b>姓名、证件号码、手机号码等</b>。完成自助解封需同时满足以下条件：
            <ul class="content-ul">
                <li>证件号码近半年没有解除过其他账户；</li>
                <li>账户在常用安全环境下操作；</li>
                <li>账户为证件号码本人正常、合法使用，不存在将账户出租、出借、出售他人使用等异常行为。</li>
            </ul>
        </div>
        <div class="footer">
            <div class="btn cancle" @click="cancle">取消</div>
            <div :class="['btn', 'primary', disabled && 'disabled']" @click="agree">同意 <span v-show="countNum > 0">({{
                    countNum
            }}s)</span></div>
        </div>
    </div>
</template>

<script>
import navTitle from '@/components/navTitle.vue';
import sendTrackEvent from '@/until/sendTrackEvent';
import getOrderNo from '@/until/getOrderNo';
import gotoHomeUtil from '@/until/gotoHome.js';
import ajax from '../../until/ajax';
import { mapMutations } from 'vuex';

export default {
    name: 'treaty',
    components: {
        navTitle
    },
    data: function () {
        return {
            countNum: 5,
            timer: null,
            disabled: true,
            redirect_url: '',   // 回调地址
            phone_url: '',      // 链接上带的手机号
            from_url: '',       // 链接上带的来源字段
            type_url: '',       // 链接上的type字段
            json_str_url: '',   // 链接上的json_str字段
            showback_url: false,
            trackParams: {},     // 埋点信息
            queryObj: {},      // 链接上带参
            
            // 2026-01-20 修改：将链接参数传入接口，之后带上接口返回的ID跳转页面，在结果页再获取，目前只支持KBA结果页
            urlqueryId: ''
        }
    },
    mounted() {
        this.startTimeDecrease();
        const url = window.location.href;
        this.queryObj = getOrderNo(url);
        this.redirect_url = this.queryObj.redirect_url ? decodeURIComponent(this.queryObj.redirect_url) : '';
        this.phone_url = this.queryObj.phone || '';
        this.from_url = this.queryObj.from || '';
        this.type_url = this.queryObj.type || '';
        this.showback_url = this.queryObj.showback == 1 ? true : false;
        this.json_str_url = this.queryObj.json_str;
        // this.redirect_url = this.$route.query.redirect_url;
        // this.phone_url = this.$route.query.phone;
        // this.from_url = this.$route.query.from;
        // this.type_url = this.$route.query.type;
        // this.showback_url = this.$route.query.showback == 1 ? true : false;
        // 保存链接参数
        this.set_showback(this.queryObj.showback == 1 ? true : false)
        this.saveQueryObj();
        // 埋点信息
        this.trackParams = {
            from: this.from_url || '',
            type: this.type_url || '',
            redirect_url: this.redirect_url || '',
            phone: this.phone_url || '',
            json_str: this.json_str_url || '',
            urlqueryId: this.urlqueryId || ''
        }
        sendTrackEvent('53173', '授权协议页', 'load', '加载', this.trackParams);
    },
    methods: {
        ...mapMutations('userLabel', ['set_showback']),
        startTimeDecrease() {
            this.timer = setInterval(() => {
                this.countNum -= 1
                if (this.countNum === 0) {
                    clearInterval(this.timer)
                    this.disabled = false
                    this.timer = null
                }
            }, 1000)
        },
        agree() {
            // 埋点信息
            this.trackParams = {
                from: this.from_url || '',
                type: this.type_url || '',
                redirect_url: this.redirect_url || '',
                phone: this.phone_url || '',
                json_str: this.json_str_url || ''
            }
            sendTrackEvent('53174', '授权协议页', 'click', '同意授权', this.trackParams);
            this.$router.replace({
                path: '/resolve',
                query: {
                    ...(this.redirect_url && { redirect_url: this.redirect_url }),
                    ...(this.phone_url && { phone: this.phone_url }),
                    ...(this.from_url && { from: this.from_url }),
                    ...(this.type_url && { type: this.type_url }),
                    ...(this.json_str_url && { json_str: this.json_str_url }),
                    ...(this.showback_url && { showback: 1 }),
                    urlqueryId: this.urlqueryId
                }
            })
        },
        cancle() {
            // 埋点信息
            this.trackParams = {
                from: this.from_url || '',
                type: this.type_url || '',
                redirect_url: this.redirect_url || '',
                phone: this.phone_url || ''
            }
            sendTrackEvent('53175', '授权协议页', 'click', '取消授权', this.trackParams);
            gotoHomeUtil({
                ...this.queryObj,
                resultCode: '0'
            });
        },

        // 将链接参数传入接口，在结果页拿
        saveQueryObj() {
            const params = {
                redirect_url: this.queryObj.redirect_url || '',
                from: this.queryObj.from || '',
                type: this.queryObj.type || '',
                ...(this.queryObj.showback && { showback: this.queryObj.showback }),
                json_str: this.queryObj.json_str || ''
            }
            ajax.$http({
                url: process.env.VUE_APP_KBA_SERVER_URL + '/intelligence/saveSourceConfig',
                type: 'post',
                data: params
            }).then(res => {
                this.urlqueryId = res.data;
            }).catch(() => {
                sendTrackEvent('53990', '授权协议页', 'catch', '存储链接参数失败', {});
            })
        },
    }
}
</script>
<style scoped>
.container {
    height: 100vh;
    display: flex;
    flex-direction: column;
    padding-bottom: 20px;
    box-sizing: border-box;
}

.content {
    flex: 1;
    overflow-y: auto;
    padding: 20px 20px;
    background-color: #F7F8FA;
    text-indent: 2em;
    white-space: 2px;
    line-height: 30px;
}

.content-ul {
    padding: 0 20px;
    text-indent: 0;
    white-space: 2px;
    line-height: 30px;
}

.footer {
    margin-top: auto;
    display: flex;
    height: 60px;
    padding: 6px;
    box-sizing: border-box;
    /* column-gap: 8px; */
    justify-content: center;
    align-items: center;
}
.cancle{
    margin-right: 4px;
}
.primary{
    margin-left: 4px;
}
.btn {
    flex: 1;
    border: 1px solid #007aff;
    text-align: center;
    height: 48px;
    line-height: 48px;
    box-sizing: border-box;
    border-radius: 6px;
    color: #007aff;
    cursor: pointer;
}

.primary {
    color: white;
    background-color: #007aff;
}

.disabled {
    cursor: not-allowed;
    opacity: 0.5;
    pointer-events: none;
}
</style>